<template>
  <a
    class="card-item"
    :href="item.link_url"
    target="_blank"
    :class="{ 'full-card': isFull }"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <div class="card-bg" v-if="item.bg_image">
      <img :src="item.bg_image" alt="" />
    </div>
    <div class="card-content">
      <!-- 视频 -->
      <template v-if="video">
        <div class="video">
          <video
            ref="video"
            muted
            disablePictureInPicture
            loop
            playsinline
            webkit-playsinline
            x5-playsinline
            x5-video-player-type="h5"
            x5-video-orientation="portrait"
            :src="video.src"
            :poster="video.cover"
            style="object-fit: cover;"
          ></video>
        </div>
      </template>
      <!-- 其他 -->
      <template v-else>
        <!-- live2d -->
        <div class="live2d" v-show="isShow && isLoadedLive2d">
          <div class="live2d-container" ref="live2dContainerRef"></div>
        </div>
        <!-- 图片 -->
        <div class="image" :class="{ 'cover-image': item.type == 3 }" v-show="!isShow || !isLoadedLive2d">
          <img v-if="item.image" :src="item.image" alt="" />
        </div>
      </template>
    </div>

    <!-- 游戏角色 -->
    <template v-if="item.type == 1">
      <div
        class="role-info"
        :style="{
          color: item.title_color || '#222',
          background: item.title_bg_color
            ? `linear-gradient(180deg, ${changeRgbaAlpha(item.title_bg_color, 0)} 0%, ${changeRgbaAlpha(
                item.title_bg_color,
                0.94
              )} 100%)`
            : 'linear-gradient( 180deg, rgba(241,255,207,0.1) 0%, rgba(241,255,207,0.94) 100%);'
        }"
      >
        <div class="top">
          <div class="game-name" v-if="item.game" :title="item.game.name">{{ item.game.name || "-" }}</div>
          <div class="date" v-if="showDate" :style="{ background: `${changeRgbaAlpha(item.title_bg_color, 0.6)}` }">
            {{ `${dayjs(item.start_at * 1000).format("MM/DD")}` }}
          </div>
        </div>
        <div class="role-name" :title="item.title">{{ item.title }}</div>
        <div class="role-desc" :title="item.desc">{{ item.desc }}</div>
      </div>
    </template>
    <!-- 福利、新游 -->
    <template v-if="[2, 4].includes(item.type)">
      <div
        class="card-info"
        :style="{
          color: item.title_color || '#222'
        }"
      >
        <div
          class="top"
          :style="{
            background: item.title_bg_color
              ? `linear-gradient(180deg, ${changeRgbaAlpha(item.title_bg_color, 0)} 0%, ${changeRgbaAlpha(
                  item.title_bg_color,
                  0.84
                )} 110%)`
              : 'linear-gradient( 180deg, rgba(35,175,218,0.1) 0%, rgba(35,175,218,0.94) 100%);'
          }"
        >
          <div class="type-name" :title="item.desc">{{ item.desc }}</div>
          <div class="title" :title="item.title">{{ item.title }}</div>
        </div>
        <div
          class="bottom"
          :style="{
            background: item.title_bg_color
              ? `linear-gradient(180deg, ${changeRgbaAlpha(item.title_bg_color, 0.94)} 0%, ${changeRgbaAlpha(
                  item.title_bg_color,
                  0.94
                )} 120%)`
              : 'rgba(255,255,255,0.45)'
          }"
        >
          <div class="game-info">
            <img class="icon" v-if="item.game" v-lazy="item.game.icon" alt="" />
            <div class="info">
              <div class="info-top">
                <div class="name" v-if="item.game" :title="item.game.name">{{ item.game.name || "-" }}</div>
                <div class="date" v-if="showDate">
                  {{
                    item.type == 2
                      ? `${dayjs(item.start_at * 1000).format("MM/DD")} - ${dayjs(item.end_at * 1000).format("MM/DD")}`
                      : `${dayjs(item.start_at * 1000).format("MM/DD")}`
                  }}
                </div>
              </div>
              <div class="desc" v-if="item.game" :title="removeHtmlTags(item.game.description)">
                {{ removeHtmlTags(item.game.description) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- 游戏情报 -->
    <template v-if="item.type == 3">
      <div class="news-info">
        <div class="top">
          <div class="game-info">
            <img class="icon" v-if="item.game" v-lazy="item.game.icon" alt="" />
            <span class="name" v-if="item.game">{{ item.game.name || "-" }}</span>
          </div>
          <div class="date-time">{{ formatTime(item.created_at) }}</div>
        </div>
        <div class="bottom" :title="item.title">
          {{ item.title }}
        </div>
      </div>
    </template>
  </a>
</template>

<script>
import dayjs from "dayjs";
import { getSpinePlayer, changeRgbaAlpha } from "@/plugins/util";

export default {
  name: "CardItem",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    },
    isShow: {
      type: Boolean,
      default: false
    },
    canFull: {
      type: Boolean,
      default: false
    },
    showDate: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isLoadedLive2d: false,
      spinePlayer: null,
      isAnimation: false,
      initTimer: null,
      destroyTimer: null
    };
  },
  computed: {
    bigVideo() {
      return this.item.big_video_format && this.item.big_video_format.src ? this.item.big_video_format : null;
    },
    smallVideo() {
      return this.item.small_video_format && this.item.small_video_format.src ? this.item.small_video_format : null;
    },
    gameVideo() {
      return this.item.video && this.item.video.length && this.item.video[0] && this.item.video[0].src
        ? this.item.video[0]
        : null;
    },
    video() {
      if (!this.callFull) {
        return this.smallVideo;
      }
      return this.bigVideo || this.smallVideo;
    },
    live2d() {
      const live2d = this.item.live2d ? JSON.parse(this.item.live2d) : null;
      const hasData = live2d && live2d.atlas && (live2d.skel || live2d.json);
      return hasData ? live2d : null;
    },
    isFull() {
      // 有大视频或游戏视频
      return this.canFull && !!this.bigVideo;
    }
  },
  watch: {
    isShow: {
      handler(val) {
        // 有live2d,没有视频的时候初始化live2d
        if (this.live2d && !this.video) {
          if (val) {
            if (this.initTimer) clearTimeout(this.initTimer);
            this.initTimer = setTimeout(() => {
              this.initSpine();
            }, 300);
          } else {
            if (this.destroyTimer) clearTimeout(this.destroyTimer);
            this.destroyTimer = setTimeout(() => {
              this.destroySpine();
            }, 300);
          }
        }
      },
      immediate: true
    }
  },
  mounted() {
    if (this.$refs.video) {
      this.observerVideoIntersection(this.$refs.video);
    }
    this.$emit("contentLoaded", this.index);
  },
  beforeDestroy() {
    // console.log("beforeDestroy");
    this.destroySpine();
  },
  methods: {
    dayjs,
    changeRgbaAlpha,
    removeHtmlTags(str = "") {
      return str.replace(/<[^>]*>/g, "").trim();
    },
    observerVideoIntersection(videoPlayer) {
      const observer = new IntersectionObserver(entries => {
        // 当目标元素进入或离开视口时，会触发回调函数
        entries.forEach(entry => {
          // 如果目标元素进入视口
          if (entry.isIntersecting) {
            // 在这里可以执行进入视口后的操作
            // videoPlayer.setAttribute("autoplay", true);
            videoPlayer.play();
          } else {
            // console.log('out', videoPlayer)
            // 在这里可以执行离开视口后的操作
            // videoPlayer.setAttribute("autoplay", false);
            videoPlayer.pause();
          }
        });
      });
      // 开始观察目标元素
      observer.observe(videoPlayer);
    },
    destroySpine() {
      const container = this.$refs.live2dContainerRef;
      if (container) {
        if (this.spinePlayer) {
          this.spinePlayer.stopRendering();
          this.spinePlayer.dispose();
        }
        container.innerHTML = "";
        this.spinePlayer = null;
        this.isLoadedLive2d = false;
      }
    },
    formatTime(time) {
      const now = dayjs();
      const dateTime = dayjs.unix(time);
      if (now.diff(dateTime, "day") > 8) {
        return dateTime.format("YYYY年MM月DD日");
      } else if (now.diff(dateTime, "day") >= 1) {
        return now.diff(dateTime, "day") + "天前";
      } else if (now.diff(dateTime, "hour") >= 1) {
        return now.diff(dateTime, "hour") + "小时前";
      } else if (now.diff(dateTime, "minute") >= 1) {
        return now.diff(dateTime, "minute") + "分钟前";
      } else {
        return "刚刚更新";
      }
    },
    foramtUrl(url) {
      if (url.startsWith("//")) {
        return `${location.protocol}${url}`;
      } else {
        return url;
      }
    },
    handleMouseEnter() {
      // console.log("handleMouseEnter");
      if (this.isLoadedLive2d && !this.isAnimation) {
        // this.playSpineAnimation(true);
      }
    },
    handleMouseLeave() {
      // console.log("handleMouseLeave");
      if (this.isLoadedLive2d && this.isAnimation) {
        // this.pauseSpineAnimation();
      }
    },
    playSpineAnimation(loop = false) {
      if (this.spinePlayer && !this.isAnimation) {
        const animationState = this.spinePlayer.animationState.getCurrent(0);
        const animation = animationState.animation;
        // console.log(animationState);
        this.isAnimation = true;
        this.spinePlayer.setAnimation(animation.name, loop);
        this.spinePlayer.play();
        return animation;
      }
    },
    pauseSpineAnimation() {
      if (this.spinePlayer && this.isAnimation) {
        this.isAnimation = false;
        this.spinePlayer && this.spinePlayer.pause();
      }
    },
    async initSpine() {
      // console.log("initSpine", this.index, this.isShow);
      if (!this.isShow) return;
      const live2d = this.live2d;
      const container = this.$refs.live2dContainerRef;

      if (live2d && container) {
        try {
          // console.log("initSpine");
          // if (typeof window !== "undefined") {
          //   console.log(document.querySelectorAll("canvas").length);
          // }
          container.innerHTML = "";
          // container.style.opacity = 0;
          if (!live2d.skel && !live2d.json) return;
          const spine = await getSpinePlayer(live2d.skel, live2d.json);

          if (!spine) return;
          const viewport = live2d.position
            ? Object.assign({}, live2d.position, { padTop: 0, padBottom: 0, padLeft: 0, padRight: 0 })
            : undefined;
          // 预设动画
          const animation = live2d.animation || "";
          const options = {
            // Relative URLs
            atlasUrl: this.foramtUrl(live2d.atlas),
            showLoading: false,
            showControls: false,
            animation: animation,
            alpha: true,
            backgroundColor: "#00000000",
            viewport: viewport,
            success: player => {
              // console.log("success", player);
              // 异步设置，等待player还有未完成的初始化
              setTimeout(() => {
                this.spinePlayer = Object.seal(player);
                // player.setAnimation(animation, false);
                // player.pause();
                this.isLoadedLive2d = true;
                this.$emit("live2dLoaded", this.index);
              }, 1000);
            }
          };
          if (live2d.json) {
            options.jsonUrl = this.foramtUrl(live2d.json);
          }
          if (live2d.skel) {
            options.skelUrl = this.foramtUrl(live2d.skel);
          }
          // eslint-disable-next-line no-new
          new spine.SpinePlayer(container, options);
        } catch (e) {
          console.error(e);
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.card-item {
  display: block;
  position: relative;
  width: 440px;
  height: 600px;
  border-radius: 20px 20px 20px 20px;
  background: #e3e3e3;
  &.full-card {
    width: 100%;
    height: 100%;
    border-radius: 20px 20px 0 0;
    overflow: hidden;
    .card-content {
      width: 100%;
      height: 100%;
      left: 0;
      .video {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 20px 20px 0 0;
        overflow: hidden;
        video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .card-info {
      display: none;
    }
  }
  .card-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px 20px 20px 20px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .card-content {
    position: absolute;
    left: -20px;
    bottom: 0;
    z-index: 1;
    width: 480px;
    height: 660px;
    pointer-events: none;

    .image {
      width: 100%;
      height: 100%;
      &.cover-image {
        position: absolute;
        top: 58px;
        left: 20px;
        width: 440px;
        height: 600px;
        border-radius: 20px 20px 20px 20px;
        overflow: hidden;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .live2d {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      .live2d-container {
        width: 100%;
        height: 100%;
      }
    }
    .video {
      position: absolute;
      top: 58px;
      left: 20px;
      width: 440px;
      height: 600px;
      border-radius: 20px 20px 20px 20px;
      overflow: hidden;
      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .role-info {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 2;
    width: 100%;
    height: 170px;
    background: linear-gradient(180deg, rgba(241, 255, 207, 0.1) 0%, rgba(241, 255, 207, 0.94) 100%);
    border-radius: 0px 0px 20px 20px;
    padding: 32px 20px 0;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 11px;
      .game-name {
        flex: 1;
        font-weight: 500;
        font-size: 17px;
        line-height: 24px;

        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .date {
        flex-shrink: 0;
        padding: 0 10px;
        display: inline-block;
        height: 21px;
        line-height: 21px;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 13px 13px 13px 13px;
        font-weight: 400;
        font-size: 15px;
      }
    }

    .role-name {
      font-weight: 600;
      font-size: 35px;
      line-height: 49px;
      margin-bottom: 9px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .role-desc {
      width: 100%;
      height: 25px;
      font-weight: 400;
      font-size: 18px;
      line-height: 25px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  .card-info {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 2;
    width: 100%;
    height: 203px;
    border-radius: 0px 0px 20px 20px;
    .top {
      width: 100%;
      height: 117px;
      padding: 30px 20px 0;
    }
    .bottom {
      height: 86px;
      border-radius: 0px 0px 20px 20px;
      overflow: hidden;
      padding: 14px 22px 15px;
    }
    .type-name {
      font-weight: 400;
      font-size: 17px;
      line-height: 24px;
      margin-bottom: 10px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .title {
      width: 100%;
      font-weight: 600;
      font-size: 30px;
      line-height: 42px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .game-info {
      display: flex;
      .icon {
        width: 57px;
        height: 57px;
        border-radius: 12px 12px 12px 12px;
        border: 1px solid #ffffff;
        margin-right: 14px;
      }
      .info {
        padding-top: 4px;
        .info-top {
          height: 25px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 7px;
          .name {
            flex: 1;
            display: block;
            width: 300px;
            font-weight: 500;
            font-size: 16px;
            line-height: 25px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .date {
            flex-shrink: 0;
            padding: 0 10px;
            display: inline-block;
            height: 21px;
            line-height: 21px;
            background: rgba(255, 255, 255, 0.25);
            border-radius: 13px 13px 13px 13px;
            font-weight: 400;
            font-size: 15px;
          }
        }

        .desc {
          display: block;
          width: 330px;
          height: 20px;
          font-weight: 400;
          font-size: 16px;
          line-height: 22px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }

  .news-info {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 2;
    width: 100%;
    height: 125px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.04) 0%, rgba(0, 0, 0, 0.24) 100%);
    border-radius: 0px 0px 20px 20px;
    backdrop-filter: blur(5px);
    padding: 21px 20px 0;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      gap: 20px;
      .game-info {
        display: inline-block;
        height: 47px;
        line-height: 37px;
        background: rgba(255, 255, 255, 0.09);
        border-radius: 10px 10px 10px 10px;
        padding: 5px 12px 5px 8px;
        .icon {
          flex-shrink: 0;
          width: 37px;
          height: 37px;
          border-radius: 10px 10px 10px 10px;
          margin-right: 10px;
          vertical-align: middle;
        }
        .name {
          flex: 1;
          display: inline-block;
          max-width: 220px;
          font-weight: 400;
          font-size: 13px;
          color: #ffffff;
          vertical-align: middle;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
      .date-time {
        flex-shrink: 0;
        font-weight: 400;
        font-size: 12px;
        color: #c6c6c6;
        text-align: right;
      }
    }
    .bottom {
      font-weight: 500;
      font-size: 18px;
      color: #ffffff;
    }
  }
}
</style>
